import styled from 'styled-components';

import { IconChevron, IconSortArrow } from '../icon';
import { Text } from '../Text';

export const DataTable = styled.table`
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    font-weight: 300;

    > tbody > tr:last-child {
        border-bottom: 1px solid ${({ theme }) => theme.border.light};
    }
`;

export const DataTableCell = styled.td<{ $width?: number }>`
    height: 60px;
    padding: 0 8px;
    width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
`;

export const DataTableRow = styled.tr`
    border-top: 1px solid ${({ theme }) => theme.border.light};
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'initial')};

    &:hover {
        background-color: ${({ theme }) => theme.container.secondaryBackground};
    }

    ${DataTableCell}:not(:last-child) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const HeaderRow = styled(DataTableRow)`
    border-top: none;
    &:hover {
        background-color: transparent;
    }
`;

export const StyledDataTableHeaderCell = styled(DataTableCell)`
    position: relative;
    user-select: none;
`;

export const ResizeHandle = styled.div<{ $isResizing: boolean }>`
    position: absolute;
    top: 0;
    right: -4px;
    width: 8px;
    height: 100%;
    cursor: col-resize;
    touch-action: none;
    user-select: none;
    z-index: 1;

    &::after {
        content: '';
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translateX(-50%);
        width: 2px;
        height: 70%;
        border-radius: 1px;
        background-color: ${({ $isResizing, theme }) => ($isResizing ? theme.colors.cocoa500 : theme.border.light)};
        transition: background-color 0.15s ease;
    }

    &:hover::after {
        background-color: ${({ theme }) => theme.colors.cocoa500};
    }
`;

export const SortArrow = styled(IconSortArrow)<{ $active?: boolean; $desc?: boolean }>`
    margin-left: 8px;
    margin-top: -2px;
    ${({ $desc }) => !$desc && 'transform: rotate(180deg);'}
    & > path {
        fill: ${({ $active, theme }) => ($active ? theme.colors.cocoa700 : theme.colors.cocoa200)};
    }
`;

export const PageNumber = styled(Text)<{ $selected?: boolean }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    padding-inline: 12px;
    width: fit-content;
    height: 30px;
    color: ${({ $selected, theme }) => ($selected ? theme.text.link : 'inherit')};
    background-color: ${({ $selected, theme }) => ($selected ? theme.container.secondaryBackground : 'transparent')};
    &:hover {
        color: ${({ theme }) => theme.text.link};
        background-color: ${({ theme }) => theme.container.secondaryBackground};
    }
`;

export const PageNumberDots = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding-inline: 12px;
`;

export const ArrowIconWrapper = styled.button<{ $left?: boolean; $disabled: boolean; $rotateRight?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    margin-right: ${({ $left }) => ($left ? '12px' : '')};
    margin-left: ${({ $left }) => ($left ? '' : '12px')};
    border-radius: 3px;
    transform: ${({ $rotateRight }) => ($rotateRight ? 'rotate(180deg)' : '')};
    color: ${({ $disabled, theme }) => ($disabled ? theme.text.disabled : 'inherit')};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
    &:hover {
        color: ${({ $disabled, theme }) => ($disabled ? theme.text.disabled : theme.text.link)};
        background-color: ${({ $disabled, theme }) =>
            $disabled ? 'transparent' : theme.container.secondaryBackground};
    }
`;

export const RightIconChevron = styled(IconChevron)`
    transform: rotate(180deg);
`;
